import React from 'react';
import './Games.css';
import iconGooglePlay from '../assets/icon_googleplay.webp';
import iconAppStore from '../assets/icon_appstore.webp';

const Games = () => {
  const games = [
    {
      title: 'Puzzle Rush',
      category: 'Puzzle',
      downloads: '15M+',
      rating: 4.8,
      description: 'Addictive puzzle game with colorful graphics and challenging levels that keep players engaged for hours.',
      features: ['500+ Levels', 'Daily Challenges', 'Power-ups', 'Leaderboards'],
      icon: '🧩'
    },
    {
      title: 'Jump Master',
      category: 'Arcade',
      downloads: '12M+',
      rating: 4.7,
      description: 'Simple yet challenging jumping game with perfect physics and satisfying gameplay mechanics.',
      features: ['Endless Mode', 'Character Skins', 'Achievements', 'Social Sharing'],
      icon: '🏃'
    },
    {
      title: 'Color Match',
      category: 'Casual',
      downloads: '10M+',
      rating: 4.9,
      description: 'Relaxing color-matching game perfect for quick play sessions with beautiful visual effects.',
      features: ['Zen Mode', 'Multiple Themes', 'Offline Play', 'Statistics'],
      icon: '🎨'
    },
    {
      title: 'Stack Tower',
      category: 'Skill',
      downloads: '8M+',
      rating: 4.6,
      description: 'Test your precision and timing in this addictive tower-building game with progressive difficulty.',
      features: ['Global Rankings', 'Perfect Streak Bonus', 'Unlock Themes', 'Share Scores'],
      icon: '🏗️'
    },
    {
      title: 'Tap Frenzy',
      category: 'Action',
      downloads: '20M+',
      rating: 4.8,
      description: 'Fast-paced tapping game that challenges reflexes with increasing speed and complexity.',
      features: ['Multiple Game Modes', 'Power-ups', 'Weekly Tournaments', 'Rewards System'],
      icon: '⚡'
    },
    {
      title: 'Maze Runner',
      category: 'Adventure',
      downloads: '6M+',
      rating: 4.5,
      description: 'Navigate through intricate mazes with smooth controls and progressively challenging layouts.',
      features: ['200+ Mazes', 'Time Challenges', 'Hint System', 'Custom Levels'],
      icon: '🌀'
    }
  ];

  return (
    <section id="games" className="games section">
      <div className="container">
        <div className="games-header">
          <h2 className="section-title">Our Games Portfolio</h2>
          <p className="section-subtitle">
            Discover our collection of successful hyper-casual games that have captured the hearts of millions of players worldwide
          </p>
        </div>

        <div className="games-grid">
          {games.map((game, index) => (
            <div key={index} className="game-card">
              <div className="game-header">
                <div className="game-icon">{game.icon}</div>
                <div className="game-info">
                  <h3 className="game-title">{game.title}</h3>
                  <span className="game-category">{game.category}</span>
                </div>
              </div>

              <div className="game-stats">
                <div className="stat">
                  <span className="stat-value">{game.downloads}</span>
                  <span className="stat-label">Downloads</span>
                </div>
                <div className="stat">
                  <span className="stat-value">★ {game.rating}</span>
                  <span className="stat-label">Rating</span>
                </div>
              </div>

              <p className="game-description">{game.description}</p>

              <div className="game-features">
                <h4>Key Features:</h4>
                <ul>
                  {game.features.map((feature, featureIndex) => (
                    <li key={featureIndex}>{feature}</li>
                  ))}
                </ul>
              </div>

              <div className="game-platforms">
                <div className="platform-badge">
                  <img src={iconGooglePlay} alt="Google Play" />
                  <span>Google Play</span>
                </div>
                <div className="platform-badge">
                  <img src={iconAppStore} alt="App Store" />
                  <span>App Store</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="games-cta">
          <h3>Want to see more of our games?</h3>
          <p>We're constantly developing new and exciting hyper-casual games. Stay tuned for upcoming releases!</p>
        </div>
      </div>
    </section>
  );
};

export default Games;
